import React, { Component, Fragment } from 'react'
import {
  formatDate,
  formatDateStandard,
  convertStringsToNumbers,
} from '../../global/formatters/string-formatter.js'
import * as FundUtility from '../FundDetails/Helpers/FundUtility.js'
import TableUtility from '../FundDetails/Helpers/TableUtility.js'

class HistoricalDataDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sortOrder: 'asc',
      sortField: 'date',
      selectedInterval: 0,
    }
  }

  getHistoricalDates(data) {
    if (!data) {
      return []
    }

    const dates = data.map((month) => {
      return month.date
    })

    return dates
  }

  getFieldsFromData(fieldData) {
    const fieldMapping = {
      date: {
        index: 0,
        value: 'Date',
      },
      liquidAssetsDailyPercentage: {
        index: 2,
        value: 'Daily Liquid Assets',
      },
      liquidAssetsWeeklyPercentage: {
        index: 3,
        value: 'Weekly Liquid Assets',
      },
      mktNAV: {
        index: 1,
        value: 'Market NAV',
      },
      netShareholderFlows: {
        index: 4,
        value: 'Net Shareholder Flows',
      },
    }
    const keys = Object.keys(fieldData)
    const fields = []

    keys.forEach((key) => {
      const obj = fieldMapping[key]

      if (obj) {
        fields.splice(obj.index, 0, {
          name: key,
          header: obj.value,
        })
      }
    })

    return fields
  }

  formatValues(rowData) {
    let formattedValues = []

    rowData.forEach((row) => {
      const keys = Object.keys(row)
      const formattedRow = {}

      keys.forEach((key) => {
        // blank or empty data should remain unformatted.
        if (!row[key] || row[key] === '-') {
          formattedRow[key] = row[key]
          return
        }

        switch (key) {
          case 'date':
            formattedRow[key] = formatDateStandard(row[key])
            break
          case 'liquidAssetsDailyPercentage':
          case 'liquidAssetsWeeklyPercentage':
            formattedRow[key] = row[key] + '%'
            break
          case 'mktNAV':
            formattedRow[key] = '$' + row[key]
            break
          case 'netShareholderFlows': {
            let value = row[key]
            const num = convertStringsToNumbers([value])
            let className = ''
            let display = '$' + value

            if (num > 0) {
              className = 'positive'
              display = '$+' + value
            } else if (num < 0) {
              className = 'negative'
            }

            formattedRow[key] = <span className={className}>{display}</span>

            break
          }
          default:
            formattedRow[key] = row[key]
            break
        }
      })

      formattedValues.push(formattedRow)
    })

    return formattedValues
  }

  sortHoldings = (holdings, sorting) => {
    if (sorting) {
      const { sortOrder, sortField } = sorting

      if (sortOrder && sortField) {
        holdings = FundUtility.sortHoldings(holdings, sortOrder, sortField)
      }
    }

    return holdings
  }

  handleSortClick(event) {
    let sortField = event.currentTarget.dataset.sortField
    let sortOrder = event.currentTarget.dataset.sortOrder

    sortOrder = sortOrder === 'asc' ? 'desc' : 'asc'

    this.setState((state) => {
      state.sortOrder = sortOrder
      state.sortField = sortField

      return state
    })
  }

  handleIntervalChange(event) {
    const { value } = event.target || {}
    const { data } = this.props
    let selectedInterval = 0

    for (let i = 0; i < data.length; i++) {
      if (data[i].date === value) {
        selectedInterval = i
        break
      }
    }

    this.setState({
      selectedInterval: selectedInterval,
    })
  }

  handleBackButton(event) {
    event.preventDefault()

    const url = window.location.href
    const urlParts = url.split('historical-data')

    window.location.href = urlParts.join('details')
  }

  _renderDateDropdown() {
    const { data } = this.props
    const historicalDates = this.getHistoricalDates(data)

    return (
      <Fragment>
        <div className="u-floatLeft u-paddingRight2gu u-paddingTop1gu">
          <span>View data as of</span>
        </div>
        <div className="u-floatRight">
          <div
            id="historical-data-dropdown-container"
            className="Dropdown date-dropdown-template"
          >
            <select
              id="historical-data-dropdown"
              className="Dropdown-menu"
              onChange={this.handleIntervalChange.bind(this)}
            >
              {historicalDates.map((date, index) => {
                const formattedDate = formatDate(date, true)

                return (
                  <option key={formattedDate + index} value={date}>
                    {formattedDate}
                  </option>
                )
              })}
            </select>
          </div>
        </div>
      </Fragment>
    )
  }

  _renderDisclosure() {
    return (
      <div className="u-sizeConstrained">
        <div className="Disclaimer">
          <Fragment>
            <p className="Disclaimer-text">
              The Market NAV is reported on the share class level while the
              other data points are reported on the fund level.
            </p>
          </Fragment>
        </div>
      </div>
    )
  }

  _renderHoldingsTable(mappedData) {
    const tableData = {
      fields: mappedData.fields,
      keyId: 'historical-data-0',
      selector: 'historical-data-table',
      sorting: mappedData.sorting,
      sortClick: this.handleSortClick.bind(this),
      type: 'default',
      values: this.formatValues(mappedData.values),
    }

    return <TableUtility data={tableData} />
  }

  _renderHistoricalDataTableWrapper() {
    const { data } = this.props
    const sorting = {
      sortField: this.state.sortField,
      sortOrder: this.state.sortOrder,
    }
    const monthData = data[this.state.selectedInterval]
    let hasData = false
    let mappedData = {}

    if (monthData) {
      hasData = monthData.historicalData && monthData.historicalData.length > 0

      mappedData = {
        collapseId: 'hd-table-collapse-1001',
        fields: hasData
          ? this.getFieldsFromData(monthData.historicalData[0])
          : [],
        sorting: Object.assign({}, sorting),
        values: hasData
          ? this.sortHoldings(monthData.historicalData, sorting)
          : [],
      }
    }

    return (
      <div className="u-bgColorLightest u-paddingVert3gu">
        <div className="u-sizeConstrained">
          <div id={mappedData.collapseId} className="collapse in">
            <div className="cti-table-title-container">
              <div className="table-responsive">
                {hasData && this._renderHoldingsTable(mappedData)}
              </div>
            </div>
          </div>
          <div className="u-bgColorWhite u-paddingVert6gu u-paddingHoriz3gu u-marginBottom3gu">
            <a href="#" className="back-button" onClick={this.handleBackButton}>
              Back to product overview
            </a>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { data } = this.props

    return (
      <div id="historical-data" className="u-adel-reset">
        <div className="u-sizeConstrained u-marginTop6gu">
          <div className="u-marginTop4gu u-marginBottom3gu u-flex">
            <h4 className="u-marginBottom0 u-flexGrow1 u-textUppercase">
              Historical 6 Month Data
            </h4>
            {this._renderDateDropdown()}
          </div>
        </div>
        <div id="historical-data-disclosure" className="u-marginBottom2gu">
          {this._renderDisclosure(this.props.fundGroup)}
        </div>
        <div id="historical-data-table" className="u-paddingTop6gu u-overflowX">
          {data && this._renderHistoricalDataTableWrapper()}
        </div>
      </div>
    )
  }
}

export default HistoricalDataDetails
